
























































































































































































































































































































































































































































































































































































































































import Vue from "vue";
import { Component, Watch, Prop, PropSync } from "vue-property-decorator";
import store from "../../../vuex/store";
import ShipmentDate from "@/components/shipments/ShipmentsManagement/ShipmentDate.vue";
import {
  MbeServiceDTO,
  CourierDTO,
  CourierServiceDTO,
  CountryDTO
} from "@/model/data.model";
import {
  ShipmentSearchFilters,
  OnlineMbePackTypeDef
} from "@/model/component.model";
import { PriceListService } from "@/services/PriceListService";
import { TranslatedCountryDTO } from "@/model/component.model";
import { fieldSorter, isFrance, isGermany } from "@/services/Helpers";
import { CustomerService } from "@/services/CustomerService";

@Component({
  components: {
    ShipmentDate: ShipmentDate
  }
})
export default class Filters extends Vue {
  @Prop() filters: ShipmentSearchFilters;
  @Prop({ type: Boolean, default: false }) isWine: boolean;

  services: MbeServiceDTO[] = [];
  couriers: CourierDTO[] = [];
  courierServices: CourierServiceDTO[] = [];
  courierServiceSelected: CourierServiceDTO | null = null;
  packageTypes: OnlineMbePackTypeDef[] = [];
  countries: CountryDTO[] = [];

  created() {
    this.loadServices();
    this.loadCouriers();
    this.loadPackageTypes();
    this.loadCountries();
  }

  loadServices() {
    PriceListService.getMbeServices().then(
      (res: MbeServiceDTO[]) => (this.services = res)
    );
  }

  loadCouriers() {
    if (this.filters.mbeService !== null) {
      PriceListService.getCouriers(
        0,
        0,
        "",
        this.filters.mbeService.idMBEBusiness
      ).then((res: CourierDTO[]) => (this.couriers = res));
    } else {
      PriceListService.getCouriers().then(
        (res: CourierDTO[]) => (this.couriers = res)
      );
    }
  }

  @Watch("filters.mbeService")
  mbeServiceChanged() {
    this.loadCouriers();
    this.loadCourierServices();
  }

  @Watch("filters.courier")
  loadCourierServices() {
    if (this.filters.courier !== null) {
      this.filters.courierService = null;
      if (this.filters.mbeService !== null) {
        PriceListService.getCourierServices(
          this.filters.courier.idCourier,
          0,
          0,
          "",
          0,
          this.filters.mbeService.idMBEBusiness
        ).then((res: CourierServiceDTO[]) => (this.courierServices = res));
      } else {
        PriceListService.getCourierServices(
          this.filters.courier.idCourier
        ).then((res: CourierServiceDTO[]) => (this.courierServices = res));
      }
    }
  }

  loadPackageTypes() {
    CustomerService.getCustomerPackTypes().then(res => {
      this.packageTypes = res.map(item => {
        const translatedMbePackageType = {
          ...item
        } as OnlineMbePackTypeDef;
        translatedMbePackageType.translatedPackTypeDescription = this.$t(
          "mbePackageType_" + item.packtypeBusinessId
        ).toString();
        return translatedMbePackageType;
      });
    });
  }

  loadCountries() {
    store.cache
      .dispatch("cachemod/getCountries")
      .then((countries: CountryDTO[]) => {
        countries.sort((a: CountryDTO, b: CountryDTO) =>
          a.name < b.name ? -1 : 1
        );
        this.countries = countries
          .map(
            (country: CountryDTO): TranslatedCountryDTO => {
              const translatedCountry = { ...country } as TranslatedCountryDTO;
              translatedCountry.translatedName = this.$t(
                "country_" + country.id
              ).toString();
              return translatedCountry;
            }
          )
          .sort(fieldSorter(["translatedName"]));
      });
  }

  isShipmentStatusContaining(input: string) {
    if (this.filters.shipmentStatus != null) {
      const elm = this.filters.shipmentStatus.find(item => item === input);
      return elm !== undefined;
    }
    return false;
  }

  handleHasAttachment(event: any) {
    const hasNoAttachment =
      this.filters.hasAttachment === false && event === true;
    this.filters.hasAttachment = hasNoAttachment ? null : event;
  }

  handleSentPaperlessDocument(event: any) {
    const hasNoSentPaperlessDocument =
      this.filters.sentPaperlessDocument === false && event === true;
    this.filters.sentPaperlessDocument = hasNoSentPaperlessDocument
      ? null
      : event;
  }

  handleIsEcommerceReturn(event: any) {
    const hasNoIsEcommerceReturn =
      this.filters.isEcommerceReturn === false && event === true;

    this.filters.isEcommerceReturn = hasNoIsEcommerceReturn ? null : event;
  }

  handleCourierManifest(event: any) {
    const courierManifest =
      this.filters.courierManifest === false && event === true;
    this.filters.courierManifest = courierManifest ? null : event;
  }

  toggleShipmentStatusFilter(input: string) {
    if (
      this.filters.shipmentStatus != null &&
      this.isShipmentStatusContaining(input)
    ) {
      this.filters.shipmentStatus = this.filters.shipmentStatus.filter(
        item => item !== input
      );
    } else {
      if (this.filters.shipmentStatus === null)
        this.filters.shipmentStatus = [];
      this.filters.shipmentStatus.push(input);
    }
    //Check: if array is empty, it becomes null
    if (
      this.filters.shipmentStatus != null &&
      this.filters.shipmentStatus.length === 0
    )
      this.filters.shipmentStatus = null;
  }

  get germany() {
    return isGermany();
  }

  get isSearchButtonDisabled() {
    return !this.areDatesValid;
  }

  get areDatesValid() {
    return (
      (this.filters.dateStart && this.filters.dateEnd) ||
      (this.filters.dateStart && this.filters.onlyFutureDates)
    );
  }

  datesChangeHandler(event: any) {
    this.$emit("datesChanged", event);
  }

  onlyFutureDatesChangeHandler(event: any) {
    this.$emit("onlyFutureDatesChanged", event);
  }

  resetFiltersButtonPressedHandler() {
    (this.$refs.datesComponent as ShipmentDate).resetState();
    this.$emit("resetFilters");
  }
}
